import { Action } from 'redux';

import { AddFieldToSortOrder } from '~src/bootstrap/redux/actions/AppActionTypes';

export interface AddFieldToSortOrderAction extends Action {
  field: string;
}

export function addFieldToSortOrder(field: string): AddFieldToSortOrderAction {
  return {
    type: AddFieldToSortOrder,
    field
  };
}
